@if (!data.categoryId) {
  <div class="modal-content cnt-dashboard border-0">
    <form
      (ngSubmit)="(subcateogryForm.form.valid)"
      #subcateogryForm="ngForm"
      novalidate
    >
      <div
        class="modal-body bg-gris-1 p-5 pb-3 d-flex align-items-center flex-column"
      >
        <h2 class="text-1 fs-4 text-center mb-4">
          {{ 'COMMON.ADDNEWSUBCATEGORY' | translate }}
        </h2>
        <i
          #closebutton
          type="button"
          class="color-4 fs-2 far fa-times-circle position-absolute end-0 top-0 m-3"
          (click)="closeDialog()"
        ></i>
        @if (!data.categoryId) {
          <mat-form-field class="example-full-width mb-3" appearance="outline">
            <mat-label>{{ 'COMMON.SELECTCATEGORY' | translate }}</mat-label>
            <mat-select
              [(ngModel)]="subCategoryAddModel.categoryId"
              name="categoryId"
              #categoryId="ngModel"
              required
            >
              @for (category of categoryList; track category) {
                <mat-option [value]="category.id">
                  {{ category.name }}
                </mat-option>
              }
            </mat-select>
            @if (
              categoryId.invalid && (categoryId.dirty || categoryId.touched)
            ) {
              <mat-error class="mt-3">
                {{ 'COMMON.ERRORCATEGORYREQUIRED' | translate }}
              </mat-error>
            }
            <!-- <div *ngIf="categoryId.invalid && (categoryId.dirty || categoryId.touched)" class="alert error_message">
          <div *ngIf="categoryId.errors?.required">
            {{"ITEMS.ERRORCATEGORYREQUIRED" | translate}}
          </div>
        </div> -->
          </mat-form-field>
        }
        @if (!data.categoryId) {
          <mat-form-field appearance="outline">
            <mat-label>{{
              'ITEMS.ENTERSUBCATEGORYNAME' | translate
            }}</mat-label>
            <input
              matInput
              class="text-1"
              type="text"
              placeholder=""
              [(ngModel)]="subCategoryAddModel.name"
              name="name"
              #name="ngModel"
              required
            />
            @if (name.invalid && (name.dirty || name.touched)) {
              <mat-error class="mt-3">
                {{ 'COMMON.ERRORSUBCATEGORYREQUIRED' | translate }}
              </mat-error>
            }
            <!-- <div *ngIf="name.invalid && (name.dirty || name.touched)" class="alert error_message">
          <div *ngIf="name.errors?.required">
            {{"ITEMS.ERRORSUBCATEGORYREQUIRED" | translate}}
          </div>
        </div> -->
          </mat-form-field>
        }
        <button
          class="btn btn-1 mt-4 py-2"
          (click)="addSubCateogry(subcateogryForm)"
        >
          <i class="fa fa-plus"></i>&nbsp;&nbsp;{{ 'COMMON.Add' | translate }}
        </button>
      </div>
    </form>
  </div>
}

@if (data.categoryId) {
  <div
    class="modal-content border-0 cnt-dashboard border-r2"
    data-backdrop="static"
  >
    <form
      (ngSubmit)="(subcateogryForm.form.valid)"
      #subcateogryForm="ngForm"
      novalidate
    >
      <div
        class="modal-body bg-gris-1 p-5 d-flex align-items-center flex-column"
      >
        <h2 class="text-1 fs-4 text-center mb-4">
          {{
            (data.name ? 'Update Subcategory' : 'COMMON.ADDNEWSUBCATEGORY')
              | translate
          }}
        </h2>
        <i
          type="button"
          #closebutton
          class="color-4 fs-2 far fa-times-circle position-absolute end-0 top-0 m-3"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="closeDialog()"
        ></i>
        <input
          matInput
          class="form-control p-2 text-center w-75"
          type="text"
          placeholder="Enter Subcategory"
          [(ngModel)]="subCategoryAddModel.name"
          name="name"
          #name="ngModel"
          required
        />
        @if (name.invalid && subcateogryFormInvalid) {
          <mat-error class="mt-3">
            {{ 'COMMON.ERRORSUBCATEGORYREQUIRED' | translate }}
          </mat-error>
        }
        @if (!data.name) {
          <button
            class="btn btn-1 mt-4 py-2"
            (click)="addSubCateogry(subcateogryForm)"
          >
            <i class="fa fa-plus"></i>&nbsp;&nbsp;{{ 'COMMON.Add' | translate }}
          </button>
        }

        @if (data.name) {
          <button
            class="btn btn-1 mt-4 py-2"
            (click)="updateSubCateogry(subcateogryForm)"
          >
            &nbsp;&nbsp;{{ 'COMMON.UPDATE' | translate }}
          </button>
        }
      </div>
    </form>
  </div>
}
